import { render, staticRenderFns } from "./InputBoxplotCustomize.vue?vue&type=template&id=76e13f60&"
import script from "./InputBoxplotCustomize.vue?vue&type=script&lang=js&"
export * from "./InputBoxplotCustomize.vue?vue&type=script&lang=js&"
import style0 from "./InputBoxplotCustomize.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAutocomplete,VSelect,VSwitch})
